export default __webpack_public_path__ + "static/SRF Carasweet 5SGF7704 - Fiche de spécifications et données techniques-d7323258cb3f35ec9ddb3753aa95c2c5.pdf";